export default "__VITE_ASSET__Bj09v05o__"